// groups elements in array - takes every two elements and creates object

const groupElements = (values) => {
  let newValues = []

  for (let i = 0; i < values.length; i += 2) {
    newValues.push({
      "name": values[i],
      "results": values[i + 1]
    })
  }
  return newValues
}

export default groupElements



// WEBPACK FOOTER //
// ./src/scripts/reusable/group-array-elements.js